<template>
    <div>
        <img class="selectIcon" src="@/assets/unSelectIcon.png" alt="" srcset="">
        <div class="newMessageCard">
            <img class="profile" src="@/assets/profile.png" alt="">
            <div class="info">
                <div class="name">
                    <div class="name-text">是否</div>
                    <img class="like" src="@/assets/heart.png" alt="">
                </div>
                <div class="message">123456</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    components: {},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.newMessageCard {
    min-width: 248px;
    width: 100%;
    height: 60px;
    box-sizing: border-box;
    padding: 8px;
    background-color: #F7F9FA;
    display: flex;

    justify-content: space-between;
    border-radius: 8px;
    margin-right: 18px;

    .profile {
        width: 44px;
        height: 44px;
        margin-right: 6px;
        cursor: pointer;
    }

    .info {
        width: 80%;
        display: flex;
        flex-direction: column;

        .name {
            display: flex;
            align-items: center;
            margin-bottom: 6px;

            .name-text {
                font-weight: 500;
                font-size: 14px;
                color: #333333;
                margin-right: 6px;
            }

            .like {
                width: 12px;
                height: 12px;
            }
        }
    }

    .message {
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        word-break: break-all;
    }

}
.selectIcon {
    width: 22px;
    height: 22px;
    margin-right: 14px;
    cursor: pointer;
}
</style>